export default __webpack_public_path__ + "static/media/555.5704b310.gif";